module.exports = __webpack_public_path__ + "static/media/google-play-badge.48077254.png";